export default __webpack_public_path__ + "static/media/5d.bed5a095.png";